import React, { useState } from "react";
import { Modal } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import shareDrive from "../../Assets/Images/shareDrive.svg";
import shareEmail from "../../Assets/Images/shareEmail.svg";
import shareFb from "../../Assets/Images/shareFb.svg";
import shareInsta from "../../Assets/Images/shareInsta.svg";
import shareTwitter from "../../Assets/Images/shareTwitter.svg";

const ShareImage: React.FC = () => {
	const [open, setOpen] = useState(true);
	return (
		<Modal
			open={open}
			onClose={() => {
				setOpen(false);
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			closeAfterTransition
		>
			<Row className="model p-0 m-0">
				<Col className="mt-4 pt-1">
					<Row>
						<Row className="d-flex justify-content-center productSansBold text_18 line_height_100pc black_0C0C0C">
							Share Image
						</Row>
						<Row className="productSansLight text_15 line_height_100pc pb-1 mt-2 d-flex justify-content-center">
							Share Your Image on Social Media
						</Row>
					</Row>
					<Col className="border-top my-4 pb-1 mx-4">
						<Row className="d-flex align-items-center text-center justify-content-center mx-5 mt-3 pb-5 mb-5">
							<Col className="mt-4 pt-1">
								<img className="mb-1" src={shareFb} alt="Facebook share" />
								Facebook
							</Col>
							<Col className="mt-4 pt-1">
								<img className="mb-1" src={shareInsta} alt="Instagram share" />
								Instagram
							</Col>
							<Col className="mt-4 pt-1">
								<img
									className="mb-1"
									src={shareDrive}
									alt="Google Drive share"
								/>
								Drive
							</Col>
							<Col className="mt-4 pt-1">
								<img className="mb-1" src={shareEmail} alt="Email share" />
								Email
							</Col>
							<Col className="mt-4 pt-1">
								<img className="mb-1" src={shareTwitter} alt="Twitter share" />
								Twitter
							</Col>
						</Row>
					</Col>
				</Col>
			</Row>
		</Modal>
	);
};
export default ShareImage;
